<template>
  <div class="content">
    <settings-menu></settings-menu>
    <div class="settings-body">
      <div class="settings-body-inner">

        <div v-if="settings && settings.legacy_plan"
             class="px-8 sm:px-4 py-3 shadow-md bg-white rounded-md">
          <a href="http://help.harnessapp.com/" class="text-blue-500" target="_blank">Contact us for billing questions</a>
        </div>
        <div v-else class="row">
          <div class="col-lg-6">
            <div v-if="settings" class="s-block mb-4 shadow-md bg-white rounded-md">
              <div class="s-block-header">Payment Method</div>
              <div class="s-block-body">
                <div class="billing-info-wrap">
                  <div class="card">
                    <div class="card-icon">
                      <img v-if="settings.brand"
                           v-bind:src="require(`../../assets/cards/${settings.brand
               .toLocaleLowerCase()
               .replace('diners club', 'diners')
               .replace('american express', 'amex')}.svg`)">

                    </div>
                    <div class="number">•••• •••• ••••<span>{{settings.last_4}}</span></div>
                    <span style="opacity: 0.7">Valid Thru {{settings.exp_month}}/{{settings.exp_year}}</span>
                  </div>
                  <div class="billing-info">
                    <div class="sub-title">Billing Information</div>
                    <a v-on:click.prevent="editPayment" href="#">Edit/Change Billing</a>
                    <p><span>Payment Method:</span> Card</p>
                    <p v-if="settings.subscription && settings.subscription.next_payment_date"><span>Next Payment:</span>
                      {{settings.subscription.next_payment_date | dateFormat('MMM D, YY')}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div v-if="settings" class="s-block">
              <div class="s-block-header">Invoices</div>
              <div class="s-block-body d-block">

                <div v-if="!settings.invoices.length" class="placeholder-block hidden">
                  <div class="label">No Invoices Yet</div>
                  <p>Your invoices will show up here</p>
                </div>
                <div v-else class="contacts-list">
                  <table class="table">
                    <tbody>
                    <tr v-for="(invoice, index) in settings.invoices"
                        :key="index">
                      <td>
                        <font-awesome-icon :icon="['fas', (invoice.paid ? 'check-circle' : 'times-circle')]"/>
                      </td>
                      <td>
                        {{invoice.date | dateFormat('MMM D, YY')}}
                        <div class="info">Invoice Date</div>
                      </td>
                      <td>${{invoice.amount / 100 | formatMoney}}
                        <div class="info">Amount</div>
                      </td>
                      <td>
                        {{invoice.interval.replace('year', 'Annually').replace('month', 'Monthly')}}
                        <div class="info">Type</div>
                      </td>
                      <td>
                        <a :href="invoice.pdf"><span class="txt-blue">Download</span></a>
                        <div class="info">PDF Receipt</div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import {
  getOrganizationBillingSettings,
  updateOrganizationBillingCard
} from '@/utils/api';
  import SettingsMenu from './menu.vue';
  import StripeCheckout from 'StripeCheckout';
  import config from '../../../public/harness_config.json';

import {mapState} from "vuex";

  export default {
    name: 'Billing',
    metaInfo: {
      title: 'Settings - Billing',
    },
    mounted() {
      // getOrganizationBillingPlan().then(plan => {
      //   console.log({plan})
      // });
      const self = this;
      this.loadBillingSettings();

      this.handler = StripeCheckout.configure({
        key: config.stripe.public_token,
        locale: 'auto',
        token: function(token) {
          self.settings = null;
          updateOrganizationBillingCard(token.id).then(() => {
            self.loadBillingSettings();
          });
        },
      });
    },
    methods: {
      loadBillingSettings() {
        getOrganizationBillingSettings().then(settings => this.settings = settings);
      },
      editPayment() {
        this.handler.open({
          name: 'Harness',
          description: 'Update Card Details',
          zipCode: true,
          panelLabel: 'Update Card Details',
        });
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
      }),
    },
    watch: {
      'activeCharityId'() {
        this.settings = null;
        this.loadBillingSettings();
      },
    },
    components: {
      SettingsMenu,
    },
    data() {
      return {
        settings: null,
        handler: null,
      };
    },
  };
</script>
